<template>
  <div class="global-variables-page w-full flex flex-col settings-page-card py-16 px-12">
    <div class="flex justify-between items-center w-full gap-2.5">
      <h1 class="text-2xl font-semibold leading-none mb-0">
        Global Variables
      </h1>

      <div
        v-if="canUpdateVariables"
        class="flex items-center justify-end gap-2.5"
      >
        <b-btn
          v-if="!activeFolder"
          class="d-flex align-items-center text-primary px-4 h-[40px]"
          variant="white"
          @click="() => {
            addFolderModal = true
            folderManage = null
          }"
        >
          <svg
            class="mr-2"
            width="18"
            height="15"
            viewBox="0 0 18 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.2814 4.40492C17.1903 4.30198 17.0601 4.24316 16.9234 4.24316H15.0484V2.55146C15.0484 2.28314 14.8332 2.06562 14.5678 2.06562H6.31973V1.48584C6.31973 1.21753 6.10456 1 5.83915 1H1.48059C1.21517 1 1 1.21753 1 1.48584L1.00058 14.181C0.999712 14.293 1.03691 14.4029 1.10813 14.4912C1.19941 14.6043 1.33615 14.67 1.48059 14.67H15.8887C16.1336 14.67 16.3394 14.4837 16.3664 14.2376L17.4011 4.78238C17.4161 4.64512 17.3726 4.50785 17.2814 4.40492ZM1.96118 1.97169H5.35857V2.55146C5.35857 2.81977 5.57375 3.0373 5.83916 3.0373H14.0872V4.24316H3.40307C3.17495 4.24316 2.97826 4.40527 2.93235 4.63119L1.96118 9.40758V1.97169ZM2.06998 13.6984H15.4583L16.3867 5.21488H3.7949L2.06998 13.6984Z"
              fill="currentColor"
            />
            <path
              d="M17.2814 4.40492L17.3937 4.30547L17.3937 4.30545L17.2814 4.40492ZM15.0484 4.24316H14.8984V4.39316H15.0484V4.24316ZM6.31973 2.06562H6.16973V2.21562H6.31973V2.06562ZM1 1.48584H0.85V1.48585L1 1.48584ZM1.00058 14.181L1.15058 14.1822L1.15058 14.181L1.00058 14.181ZM1.10813 14.4912L1.22489 14.397L1.22487 14.397L1.10813 14.4912ZM16.3664 14.2376L16.5155 14.2539V14.2539L16.3664 14.2376ZM17.4011 4.78238L17.252 4.76606V4.76607L17.4011 4.78238ZM5.35857 1.97169H5.50857V1.82169H5.35857V1.97169ZM1.96118 1.97169V1.82169H1.81118V1.97169H1.96118ZM14.0872 3.0373H14.2372V2.8873H14.0872V3.0373ZM14.0872 4.24316V4.39316H14.2372V4.24316H14.0872ZM2.93235 4.63119L3.07934 4.66108L3.07934 4.66106L2.93235 4.63119ZM1.96118 9.40758H1.81118L2.10817 9.43746L1.96118 9.40758ZM15.4583 13.6984V13.8484H15.5928L15.6074 13.7147L15.4583 13.6984ZM2.06998 13.6984L1.92298 13.6685L1.88641 13.8484H2.06998V13.6984ZM16.3867 5.21488L16.5358 5.2312L16.554 5.06488H16.3867V5.21488ZM3.7949 5.21488V5.06488H3.67233L3.6479 5.18499L3.7949 5.21488ZM16.9234 4.39316C17.0168 4.39316 17.1062 4.43335 17.1692 4.50438L17.3937 4.30545C17.2743 4.17061 17.1033 4.09316 16.9234 4.09316V4.39316ZM15.0484 4.39316H16.9234V4.09316H15.0484V4.39316ZM14.8984 2.55146V4.24316H15.1984V2.55146H14.8984ZM14.5678 2.21562C14.7488 2.21562 14.8984 2.36444 14.8984 2.55146H15.1984C15.1984 2.20184 14.9176 1.91562 14.5678 1.91562V2.21562ZM6.31973 2.21562H14.5678V1.91562H6.31973V2.21562ZM6.16973 1.48584V2.06562H6.46973V1.48584H6.16973ZM5.83915 1.15C6.02018 1.15 6.16973 1.29883 6.16973 1.48584H6.46973C6.46973 1.13623 6.18894 0.85 5.83915 0.85V1.15ZM1.48059 1.15H5.83915V0.85H1.48059V1.15ZM1.15 1.48584C1.15 1.29883 1.29955 1.15 1.48059 1.15V0.85C1.1308 0.85 0.85 1.13623 0.85 1.48584H1.15ZM1.15058 14.181L1.15 1.48584L0.85 1.48585L0.850577 14.181L1.15058 14.181ZM1.22487 14.397C1.17592 14.3363 1.14997 14.2603 1.15057 14.1822L0.850581 14.1799C0.849455 14.3257 0.8979 14.4695 0.991398 14.5854L1.22487 14.397ZM1.48059 14.52C1.38186 14.52 1.28791 14.4751 1.22489 14.397L0.991377 14.5853C1.11091 14.7335 1.29044 14.82 1.48059 14.82V14.52ZM15.8887 14.52H1.48059V14.82H15.8887V14.52ZM16.2172 14.2212C16.1985 14.3926 16.0558 14.52 15.8887 14.52V14.82C16.2115 14.82 16.4803 14.5748 16.5155 14.2539L16.2172 14.2212ZM17.252 4.76607L16.2172 14.2212L16.5155 14.2539L17.5502 4.7987L17.252 4.76607ZM17.1691 4.50436C17.2321 4.57547 17.2624 4.67065 17.252 4.76606L17.5502 4.79871C17.5698 4.61959 17.5131 4.44023 17.3937 4.30547L17.1691 4.50436ZM5.35857 1.82169H1.96118V2.12169H5.35857V1.82169ZM5.50857 2.55146V1.97169H5.20857V2.55146H5.50857ZM5.83916 2.8873C5.65812 2.8873 5.50857 2.73847 5.50857 2.55146H5.20857C5.20857 2.90107 5.48937 3.1873 5.83916 3.1873V2.8873ZM14.0872 2.8873H5.83916V3.1873H14.0872V2.8873ZM14.2372 4.24316V3.0373H13.9372V4.24316H14.2372ZM3.40307 4.39316H14.0872V4.09316H3.40307V4.39316ZM3.07934 4.66106C3.11127 4.50397 3.24737 4.39316 3.40307 4.39316V4.09316C3.10253 4.09316 2.84525 4.30657 2.78535 4.60132L3.07934 4.66106ZM2.10817 9.43746L3.07934 4.66108L2.78536 4.6013L1.81419 9.37769L2.10817 9.43746ZM1.81118 1.97169V9.40758H2.11118V1.97169H1.81118ZM15.4583 13.5484H2.06998V13.8484H15.4583V13.5484ZM16.2376 5.19856L15.3092 13.6821L15.6074 13.7147L16.5358 5.2312L16.2376 5.19856ZM3.7949 5.36488H16.3867V5.06488H3.7949V5.36488ZM2.21697 13.7283L3.94189 5.24477L3.6479 5.18499L1.92298 13.6685L2.21697 13.7283Z"
              fill="currentColor"
            />
          </svg>

          Create New Folder
        </b-btn>

        <b-btn
          class="d-flex align-items-center text-primary px-4 h-[40px]"
          variant="white"
          @click="importGlobalVariableModal = true"
        >
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2"
          >
            <path
              d="M12.6668 9.49998L9.50016 6.33331M9.50016 6.33331L6.3335 9.49998M9.50016 6.33331V13.6166C9.50016 14.7176 9.50016 15.2681 9.93599 15.8845C10.2256 16.294 11.0593 16.7994 11.5563 16.8667C12.3043 16.9681 12.5884 16.8199 13.1565 16.5235C15.6884 15.2028 17.4168 12.5532 17.4168 9.49998C17.4168 5.12772 13.8724 1.58331 9.50016 1.58331C5.12791 1.58331 1.5835 5.12773 1.5835 9.49998C1.5835 12.4303 3.17553 14.9887 5.54183 16.3575"
              stroke="#4F83E3"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Import GV
        </b-btn>

        <b-btn
          class="d-flex align-items-center px-4 h-[40px]"
          variant="primary"
          @click="addGlobalVariableModal = true"
        >
          Add New Variable
          <svg
            class="ml-2"
            fill="none"
            height="12"
            viewBox="0 0 11 12"
            width="11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.808 11.815H4.807V7.146H0.667V5.329H4.807V0.843999H6.808V5.329H10.925V7.146H6.808V11.815Z"
              fill="currentColor"
            />
          </svg>
        </b-btn>
      </div>
    </div>

    <div class="w-full flex justify-between items-center gap-2.5 mt-14">
      <GlobalVariableBreadcrumb
        :active-folder="activeFolder"
        @load-folder="activeFolder = $event"
      />

      <div class="flex items-center justify-end gap-2.5">
        <div
          class="position-relative dashboard-search after:w-0 mr-0"
          style="min-width: 325px;"
        >
          <b-input
            v-model="search"
            placeholder="Search projects…"
          />

          <svg
            v-if="!search"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.1734 11.0365C15.052 8.40038 14.8089 4.71703 12.4439 2.35203C9.80783 -0.28401 5.53397 -0.28401 2.89793 2.35203C0.261889 4.98807 0.261889 9.26193 2.89793 11.898C5.26293 14.263 8.94628 14.5061 11.5824 12.6275L18.0123 19.0574L19.6033 17.4664L13.1734 11.0365C13.1734 11.0365 15.052 8.40038 13.1734 11.0365ZM10.8529 3.94302C12.6102 5.70038 12.6102 8.54962 10.8529 10.307C9.09552 12.0643 6.24628 12.0643 4.48892 10.307C2.73156 8.54962 2.73156 5.70038 4.48892 3.94302C6.24628 2.18566 9.09552 2.18566 10.8529 3.94302C10.8529 3.94302 12.6102 5.70038 10.8529 3.94302Z"
              fill="#6E747A"
            />
          </svg>

          <b-link
            v-else
            @click="search = ''"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="w-[14px] h-[14px]"
            >
              <path
                d="M9.15207 7.5L14.7604 1.8911C14.9146 1.7367 14.9998 1.53071 15 1.31106C15 1.09129 14.9149 0.885058 14.7604 0.730901L14.2689 0.239528C14.1144 0.0847616 13.9084 0 13.6885 0C13.469 0 13.263 0.0847616 13.1085 0.239528L7.50024 5.84806L1.89171 0.239528C1.73744 0.0847616 1.53134 0 1.31159 0C1.09207 0 0.885976 0.0847616 0.731707 0.239528L0.24 0.730901C-0.08 1.05092 -0.08 1.57144 0.24 1.8911L5.84841 7.5L0.24 13.1087C0.0856097 13.2633 0.000609756 13.4693 0.000609756 13.6889C0.000609756 13.9086 0.0856097 14.1146 0.24 14.2691L0.731585 14.7605C0.885854 14.9151 1.09207 15 1.31146 15C1.53122 15 1.73732 14.9151 1.89159 14.7605L7.50012 9.15181L13.1084 14.7605C13.2629 14.9151 13.4689 15 13.6884 15H13.6887C13.9083 15 14.1143 14.9151 14.2688 14.7605L14.7602 14.2691C14.9145 14.1147 14.9996 13.9086 14.9996 13.6889C14.9996 13.4693 14.9145 13.2633 14.7602 13.1088L9.15207 7.5Z"
                fill="#6E747A"
              />
            </svg>
          </b-link>
        </div>
      </div>
    </div>

    <div class="w-full flex flex-col">
      <div
        v-if="loading"
        class="d-flex align-items-center justify-content-center min-vh-50"
      >
        <b-spinner variant="primary" />
      </div>

      <component
        :is="!canUpdateVariables ? 'div' : 'draggable'"
        v-if="!search && !activeFolder"
        :list="folders"
        handle=".move"
        :delay="200"
        :delay-on-touch-only="true"
        :filter="'.no-drag'"
        :prevent-on-filter="false"
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-8 mt-8 w-full"
        @end="updateFoldersOrder"
      >
        <GlobalVariableFolder
          v-for="folder in folders.filter(f => f.key !== null)"
          :key="folder.key"
          :folder="folder"
          :readonly="!canUpdateVariables"
          @delete="deleteFolder"
          @edit="editFolder"
          @open-folder="activeFolder = folder"
        />
      </component>

      <div
        v-if="variablesByFolder.length && canUpdateVariables"
        class="flex items-center justify-between gap-x-2.5 border border-[#DFE2E5] bg-white p-[20px] rounded-[10px] mt-[40px] shadow-[0_1px_4px_rgba(0,0,0,0.02)]"
      >
        <b-checkbox
          v-model="selectAll"
          class="rounded-[4px]"
          @change="hash = ''"
        >
          <label class="ml-[13px]">
            Select All
          </label>
        </b-checkbox>

        <div class="flex items-center gap-x-2.5">
          <b-dropdown
            variant="white"
            right
            toggle-class="text-decoration-none !rounded h-[38px] py-2.5 px-3"
            menu-class="py-0"
            no-caret
          >
            <template #button-content>
              Bulk Actions
            </template>

            <b-dropdown-item
              class="d-flex align-items-center"
              link-class="dashboard-menu-link !flex items-center text-[15px]"
              @click.stop="bulkMoveToFolder"
            >
              <svg
                width="18"
                height="14"
                viewBox="0 0 18 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 mr-2"
              >
                <g clip-path="url(#clip0_15191_86790)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.583496 2.91667C0.583496 1.95017 1.367 1.16667 2.3335 1.16667H5.8335C6.02854 1.16667 6.21067 1.26415 6.31886 1.42643L7.31235 2.91667H11.6668C12.6333 2.91667 13.4168 3.70017 13.4168 4.66667V11.0833C13.4168 12.0498 12.6333 12.8333 11.6668 12.8333H2.3335C1.367 12.8333 0.583496 12.0498 0.583496 11.0833V2.91667ZM2.3335 2.33334C2.01133 2.33334 1.75016 2.59451 1.75016 2.91667V11.0833C1.75016 11.4055 2.01133 11.6667 2.3335 11.6667H11.6668C11.989 11.6667 12.2502 11.4055 12.2502 11.0833V4.66667C12.2502 4.34451 11.989 4.08334 11.6668 4.08334H7.00016C6.80512 4.08334 6.62299 3.98586 6.5148 3.82358L5.52131 2.33334H2.3335Z"
                    fill="currentColor"
                  />
                  <rect
                    x="9.625"
                    y="4.11252"
                    width="7.875"
                    height="7.525"
                    fill="white"
                  />
                </g>
                <g clip-path="url(#clip1_15191_86790)">
                  <path
                    d="M13.566 10.0662C13.3667 10.2655 13.3667 10.5887 13.566 10.788C13.7653 10.9873 14.0885 10.9873 14.2878 10.788L16.8399 8.23592C17.0393 8.03659 17.0393 7.71341 16.8399 7.51408L14.2878 4.962C14.0885 4.76267 13.7653 4.76267 13.566 4.962C13.3667 5.16133 13.3667 5.48451 13.566 5.68384L15.2467 7.36458H6.27067C5.98878 7.36458 5.76025 7.59311 5.76025 7.875C5.76025 8.1569 5.98878 8.38542 6.27067 8.38542H15.2467L13.566 10.0662Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15191_86790">
                    <rect
                      width="14"
                      height="14"
                      fill="white"
                    />
                  </clipPath>
                  <clipPath id="clip1_15191_86790">
                    <rect
                      width="12.25"
                      height="12.25"
                      fill="white"
                      transform="translate(5.25 1.75)"
                    />
                  </clipPath>
                </defs>
              </svg>

              Move to Folder
            </b-dropdown-item>

            <b-dropdown-item
              class="d-flex align-items-center"
              link-class="dashboard-menu-link !flex items-center text-[15px]"
              @click.stop="bulkShare"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 mr-2"
              >
                <path
                  d="M14 6.00001L14 2.00001M14 2.00001H9.99999M14 2.00001L8 8M6.66667 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.07989 14 5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V9.33333"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Share
            </b-dropdown-item>

            <delete-confirm
              title="Are you sure?"
              description="Global variables will be deleted permanently."
              @confirm="bulkDelete"
            >
              <template #activator="{on}">
                <b-dropdown-item
                  class="d-flex align-items-center"
                  link-class="dashboard-menu-link !flex items-center text-[15px]"
                  v-on="on"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4 mr-2"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                      fill="currentColor"
                    />
                    <path
                      d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                      fill="currentColor"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                      fill="currentColor"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.5 0.75C7.08579 0.75 6.75 1.08579 6.75 1.5V3H3C2.58579 3 2.25 3.33579 2.25 3.75C2.25 4.16421 2.58579 4.5 3 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H11.25V1.5C11.25 1.08579 10.9142 0.75 10.5 0.75H7.5ZM9.75 3H8.25V2.25H9.75V3Z"
                      stroke="white"
                      stroke-width="0.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 8.25C7.91421 8.25 8.25 8.58579 8.25 9V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V9C6.75 8.58579 7.08579 8.25 7.5 8.25Z"
                      stroke="white"
                      stroke-width="0.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 8.58579 9.75 9V13.5C9.75 13.9142 10.0858 14.25 10.5 14.25C10.9142 14.25 11.25 13.9142 11.25 13.5V9Z"
                      stroke="white"
                      stroke-width="0.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.00001 5.25C2.78259 5.25 2.57587 5.34435 2.43341 5.5086C2.29096 5.67285 2.2268 5.89083 2.25754 6.10607L3.57356 15.3182C3.73191 16.4267 4.68123 17.25 5.80095 17.25H12.1991C13.3188 17.25 14.2681 16.4267 14.4264 15.3182L15.7425 6.10607C15.7732 5.89083 15.709 5.67285 15.5666 5.5086C15.4241 5.34435 15.2174 5.25 15 5.25H3.00001ZM5.05849 15.1061L3.86476 6.75H14.1352L12.9415 15.1061C12.8887 15.4756 12.5723 15.75 12.1991 15.75H5.80095C5.42771 15.75 5.11127 15.4756 5.05849 15.1061Z"
                      stroke="white"
                      stroke-width="0.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  Delete
                </b-dropdown-item>
              </template>
            </delete-confirm>
          </b-dropdown>
        </div>
      </div>

      <component
        :is="search ? 'div' : 'draggable'"
        v-model="variablesByFolder"
        group="folders"
        item-key="hash"
        handle=".move"
        :delay="200"
        :delay-on-touch-only="true"
        :filter="'.no-drag'"
        :prevent-on-filter="false"
        class="flex flex-col gap-y-4 mt-4 w-full"
        @end="updateVariablesOrder"
      >
        <GlobalVariableItem
          v-for="variable in variablesByFolder"
          :key="variable.hash"
          :variable="variable"
          :select-all="selectAll"
          :readonly="!canUpdateVariables"
          @edit="editVariable"
          @delete="deleteGlobalVariable(variable)"
          @move-to-folder="val => {
            moveToFolderModal = true
            variableManageList = [variables.find(item => item.hash === val.hash)]
          }"
          @on-select="onSelectGlobalVariable"
        />
      </component>
    </div>

    <GlobalVariableFolderManage
      v-model="addFolderModal"
      :folder="folderManage"
      @create="addFolder"
      @update="updateFolder"
    />

    <GlobalVariableManage
      v-model="addGlobalVariableModal"
      :active-folder="activeFolder"
      :folders="folders"
      :variable="variableManage"
      @create="addGlobalVariable"
      @update="editGlobalVariable"
    />

    <GlobalVariableMoveToFolder
      v-model="moveToFolderModal"
      :variables="variableManageList"
      :folders="folders"
      @submit="moveToFolder"
    />

    <GlobalVariableImport 
      v-model="importGlobalVariableModal"
      @submit="importGlobalVariable"
    />
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {toJSON} from '@/utils/helpers'
import draggable from 'vuedraggable'
import GlobalVariableItem from '@/views/dashboard/variables/GlobalVariableItem.vue'
import GlobalVariableFolder from '@/views/dashboard/variables/GlobalVariableFolder.vue'
import GlobalVariableFolderManage from '@/components/editor/modals/GlobalVariableFolderManage.vue'
import GlobalVariableManage from '@/components/editor/modals/GlobalVariableManage.vue'
import GlobalVariableBreadcrumb from '@/views/dashboard/variables/GlobalVariableBreadcrumb.vue'
import GlobalVariableMoveToFolder from '@/components/editor/modals/GlobalVariableMoveToFolder.vue'
import GlobalVariableImport from '@/components/editor/modals/GlobalVariableImport.vue'
import DeleteConfirm from '@/components/editor/modals/DeleteConfirm.vue'

export default {
  name: 'GlobalVariables',
  components: {
    DeleteConfirm,
    GlobalVariableImport,
    GlobalVariableMoveToFolder,
    GlobalVariableBreadcrumb,
    GlobalVariableManage,
    GlobalVariableFolderManage,
    GlobalVariableFolder,
    draggable,
    GlobalVariableItem
  },
  data () {
    return {
      loading: false,
      search: '',
      hash: '',
      selectAll: false,
      initVariablesKeys: [],
      confirmSaveDialog: false,
      addFolderModal: false,
      addGlobalVariableModal: false,
      moveToFolderModal: false,
      importGlobalVariableModal: false,
      activeFolder: null,
      folderManage: null,
      variableManage: null,
      variableManageList: [],
      variableTypes: [
        {
          value: 'link',
          text: 'Link'
        },
        {
          value: 'modal',
          text: 'Modal'
        }
      ]
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    ...mapState('modal', {
      modals: state => state.modals
    }),
    ...mapGetters('projects', {
      checkPermissions: 'checkPermissions'
    }),
    canUpdateVariables () {
      return this.checkPermissions('project_settings.variables.update')
    },
    globalVariables () {
      return toJSON(this.project.variables)
    },
    variables: {
      get () {
        const gv = toJSON(this.project.variables)
        const object = gv?.variables || {}
        return Object.entries(object).map(([key, value]) => ({
          ...value,
          hash: key
        }))
      },
      set (val) {
        const map = {}
        for (const item of Array.isArray(val) ? val : []) {
          const { hash, ...rest } = item || {}
          if (hash) map[hash] = rest
        }
        const folders = this.folders || []
        this.$set(this.project, 'variables', { folders, variables: map })
      }
    },
    variablesByFolder: {
      get () {
        const filteredByFolder = this.activeFolder
          ? this.variables.filter(item => item.folder === this.activeFolder.key)
          : this.variables.filter(item => !item.folder)

        // If searching, ignore folder filter but keep ordering
        const base = this.search
          ? this.variables.filter(item => {
            const keyword = this.search.toLowerCase()
            return (
              item.name?.toLowerCase().includes(keyword) ||
              item.key?.toLowerCase().includes(keyword)
            )
          })
          : filteredByFolder

        // Sort by explicit order (default 0) to keep draggable positions stable
        return [...base].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      },
      set (val) {
        if (!Array.isArray(val)) return

        const scopeKey = this.activeFolder ? this.activeFolder.key : null
        const allMap = this.globalVariables?.variables || {}

        // Start by copying all entries that are NOT in the current scope untouched
        const result = {}
        for (const [hash, v] of Object.entries(allMap)) {
          const folder = (v && v.folder) != null ? v.folder : null
          if (folder !== scopeKey) {
            result[hash] = v
          }
        }

        // Now write the filtered (scoped) items from the provided array
        // Optionally persist new order index as well
        val.forEach((item, index) => {
          if (!item || !item.hash) return
          const { hash, ...rest } = item
          // keep provided fields; ensure folder matches the scope
          if (!('folder' in rest)) rest.folder = scopeKey
          // record order for stability if present in UI
          result[hash] = { ...rest, order: index }
        })

        // For safety, append any scoped items that were not present in `val`
        for (const [hash, v] of Object.entries(allMap)) {
          const folder = (v && v.folder) != null ? v.folder : null
          if (folder === scopeKey && !result[hash]) {
            result[hash] = v
          }
        }

        // Write back the full structure: keep folders, replace variables map
        const folders = this.folders || []
        this.$set(this.project, 'variables', { folders, variables: result })
      }
    },
    folders: {
      get () {
        const gv = toJSON(this.project.variables)
        return gv?.folders || []
      },
      set (val) {
        const vars = (this.globalVariables && this.globalVariables.variables) || {}
        this.$set(this.project, 'variables', { folders: val || [], variables: vars })
      }
    },
    variablesKeys () {
      return this.variables.map(variable => ({
        id: variable.hash,
        key: variable.key
      }))
    }
  },
  methods: {
    async generateHash (length = 32) {
      const random = Math.floor(Math.random() * 1000000)
      const uniqid = Date.now().toString() + random.toString()

      const encoder = new TextEncoder()
      const data = encoder.encode(uniqid)

      return crypto.subtle.digest('SHA-1', data).then(hashBuffer => {
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        const hexHash = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

        // eslint-disable-next-line no-undef
        const base36 = BigInt('0x' + hexHash).toString(36)
        return base36.slice(0, length)
      })
    },
    async checkVariablesStructure () {
      // Accept a variety of legacy shapes and even JSON strings
      const coerce = (value) => {
        if (!value) return value
        if (typeof value === 'string') {
          try { return JSON.parse(value) } catch (e) { return value }
        }
        return value
      }

      // Utility to normalize folders and ensure length is correct
      const normalizeFoldersAndLengths = (foldersInput, variablesMap) => {
        const foldersArr = Array.isArray(foldersInput) ? foldersInput : []

        // Ensure every folder has { name, key, length }
        const normalizedFolders = foldersArr.map((f, idx) => {
          const name = (f && typeof f.name === 'string' && f.name.trim()) ? f.name : `Folder ${idx + 1}`
          const key = (f && typeof f.key === 'string' && f.key.trim()) ? f.key : `folder-${idx + 1}`
          const length = typeof f?.length === 'number' && isFinite(f.length) ? f.length : 0
          return { name, key, length }
        })

        const folderKeySet = new Set(normalizedFolders.map(f => f.key))

        // Drop/repair invalid folder references on variables
        const fixedVariables = {}
        for (const [hash, v] of Object.entries(variablesMap || {})) {
          const folder = (v && 'folder' in v) ? (v.folder ?? null) : null
          const safeFolder = (folder !== null && !folderKeySet.has(folder)) ? null : folder
          fixedVariables[hash] = { ...v, folder: safeFolder }
        }

        // Recount lengths from variables
        for (const f of normalizedFolders) f.length = 0
        for (const v of Object.values(fixedVariables)) {
          const fk = (v && v.folder) ?? null
          if (fk !== null) {
            const idx = normalizedFolders.findIndex(f => f.key === fk)
            if (idx !== -1) normalizedFolders[idx].length++
          }
        }

        return { folders: normalizedFolders, variables: fixedVariables }
      }

      let gv = coerce(this.project.variables)

      // Handle legacy case where the *entire* thing is a stringified array
      if (Array.isArray(gv)) {
        const map = {}
        for (const variable of gv) {
          const hash = await this.generateHash()
          map[hash] = {
            ...variable,
            type: variable.type || 'link',
            folder: variable.folder || null
          }
        }
        const { folders, variables } = normalizeFoldersAndLengths([], map)
        this.$set(this.project, 'variables', { folders, variables })
        return
      }

      // If empty or an object without folders/variables, initialize
      if (!gv || (typeof gv === 'object' && !Array.isArray(gv) && !gv.variables && !gv.folders)) {
        this.$set(this.project, 'variables', { folders: [], variables: {} })
        return
      }

      // From here on, ensure we are dealing with an object and coerce its `variables` if needed
      if (typeof gv !== 'object' || Array.isArray(gv)) {
        // Unknown shape: reset safely
        this.$set(this.project, 'variables', { folders: [], variables: {} })
        return
      }

      // Coerce inner `variables` if it is a string
      const inner = coerce(gv.variables)
      const rawFolders = Array.isArray(gv.folders) ? gv.folders : []

      // Case 2: second shape => { folders: [...], variables: Array }
      if (Array.isArray(inner)) {
        const map = {}
        for (const variable of inner) {
          const hash = await this.generateHash()
          map[hash] = {
            ...variable,
            type: variable.type || 'link',
            folder: variable.folder || null
          }
        }
        const { folders, variables } = normalizeFoldersAndLengths(rawFolders, map)
        this.$set(this.project, 'variables', { folders, variables })
        return
      }

      // Case 3: desired/modern shape => { folders: [...], variables: Object map }
      if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
        const map = {}
        for (const [hash, v] of Object.entries(inner)) {
          map[hash] = {
            ...v,
            type: v.type || 'link',
            folder: v.folder || null
          }
        }
        const { folders, variables } = normalizeFoldersAndLengths(rawFolders, map)
        this.$set(this.project, 'variables', { folders, variables })
        return
      }

      // Fallback — reset to empty safe shape
      this.$set(this.project, 'variables', { folders: rawFolders || [], variables: {} })
    },
    onSelectGlobalVariable (val) {
      if (val.checked) {
        this.hash = this.hash.length ? `${this.hash},${val.hash}` : val.hash
      } else {
        const str = this.hash.includes(`${val.hash},`) ? `${val.hash},` : val.hash
        this.hash = this.hash.replace(str, '')
      }
    },
    async addFolder (name) {
      const slugBase = String(name || '').trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-_]/g, '')

      const existing = new Set((this.folders || []).map(f => f.key))
      let key = slugBase || 'folder'
      for (let i = 2; existing.has(key); i++) key = `${slugBase || 'folder'}-${i}`

      const newFolder = { name: name?.trim() || 'New Folder', key, length: 0 }

      this.folders = [ ...(this.folders || []), newFolder ]

      await this.save()
    },
    async updateFolder (folder, name) {
      const index = this.globalVariables.folders.findIndex(f => f.key === folder.key)
      this.globalVariables.folders[index].name = name

      await this.save()
    },
    async deleteFolder (folder) {
      const gv = toJSON(this.project.variables)
      const object = gv?.variables || {}
      const list = Object.entries(object).map(([key, value]) => ({
        ...value,
        hash: key
      }))

      for (const variable of list) {
        if (variable.folder === folder.key) {
          this.globalVariables.variables[variable.hash].folder = null
        }
      }

      const index = this.globalVariables.folders.findIndex(f => f.key === folder.key)
      this.globalVariables.folders.splice(index, 1)

      await this.save()
    },
    editFolder (folder) {
      this.folderManage = folder
      this.addFolderModal = true
    },
    editVariable (variable) {
      this.variableManage = variable
      this.addGlobalVariableModal = true
    },
    async addGlobalVariable (variable) {
      const hash = await this.generateHash()

      const folder = (variable && 'folder' in variable)
        ? (variable.folder ?? null)
        : (this.activeFolder ? this.activeFolder.key : null)

      const allMap = this.globalVariables?.variables || {}
      const scopeKey = folder || null
      const scopedOrders = Object.values(allMap)
        .filter(v => ((v && v.folder) ?? null) === scopeKey)
        .map(v => (typeof v?.order === 'number' ? v.order : 0))

      const minOrder = scopedOrders.length ? Math.min(...scopedOrders) : 0
      const newOrder = minOrder - 1

      const updatedVariables = {
        ...allMap,
        [hash]: {
          ...variable,
          folder: scopeKey,
          order: newOrder
        }
      }

      this.$set(this.project, 'variables', {
        folders: this.globalVariables.folders,
        variables: updatedVariables
      })

      await this.save()
    },
    async editGlobalVariable (variable) {
      this.globalVariables.variables[variable.hash] = {
        name: variable.name,
        key: variable.key,
        type: variable.type,
        value: variable.value,
        folder: variable.folder || null
      }

      await this.save()
    },
    async deleteGlobalVariable (variable) {
      this.$delete(this.globalVariables.variables, variable.hash)
      await this.save()
    },
    async updateFoldersOrder () {
      await this.save()
    },
    async updateVariablesOrder () {
      await this.save()
    },
    async moveToFolder (variables, folder) {
      const tmp = this.globalVariables.variables[variables[0].hash]

      if (tmp.folder === folder) return

      variables.forEach(variable => {
        if (folder) {
          this.globalVariables.variables[variable.hash].folder = folder
        } else if (folder === null) {
          this.globalVariables.variables[variable.hash].folder = null
        }
      })

      await this.save()
    },
    async bulkMoveToFolder () {
      this.variableManageList = this.hash.split(',').map(item => this.variables.find(variable => variable.hash === item)).filter(Boolean)
      this.moveToFolderModal = true
    },
    async bulkShare () {
      this.$copyText(this.hash)
      this.$swal({
        icon: 'success',
        title: 'Copied!',
        toast: true,
        position: 'top-right',
        showConfirmButton: false,
        timer: 1500
      })
    },
    async bulkDelete () {
      const list = this.hash.split(',').map(item => this.variables.find(variable => variable.hash === item)).filter(Boolean)

      for (const variable of list) {
        this.$delete(this.globalVariables.variables, variable.hash)
      }

      await this.save()
    },
    cleanKeyString (key) {
      key = key.trim()

      if (key.endsWith('.')) {
        key = key.slice(0, -1)
      }

      return key
    },
    validateDomain (value) {
      const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)*\.[a-zA-Z]{2,})$/
      return domainRegex.test(value)
    },
    ensureLink (value) {
      if (this.validateDomain(value) && !/^https?:\/\//i.test(value)) {
        return `https://${value.trim()}`
      }
      return value.trim()
    },
    hasDuplicateKeys () {
      const seenKeys = new Set()
      for (const item of this.variablesKeys) {
        if (seenKeys.has(item.key)) {
          return true
        }
        seenKeys.add(item.key)
      }
      return false
    },
    checkChanges () {
      const init = new Map(this.initVariablesKeys.map(item => [item.id, item.key]))
      const current = new Map(this.variablesKeys.map(item => [item.id, item.key]))
      for (const [id, key] of init) {
        if (current.has(id) && current.get(id) !== key) {
          return true
        }
      }
      return false
    },
    handleSave () {
      const hasDuplicateKeys = this.hasDuplicateKeys()
      const isChanged = this.checkChanges()
      if (hasDuplicateKeys) {
        return this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Duplicate keys are not allowed.',
          showConfirmButton: false,
          timer: 5000
        })
      }
      if (isChanged) {
        this.confirmSaveDialog = true
      } else {
        this.save()
      }
    },
    checkFolders () {
      this.folders.forEach(folder => {
        folder.length = 0
      })

      const folders = this.folders
      const object = this.globalVariables.variables || {}
      const variables = Object.entries(object).map(([key, value]) => ({
        ...value,
        hash: key
      }))

      for (const variable of variables) {
        const index = folders.findIndex(f => f.key === variable.folder)
        if (index !== -1) {
          folders[index].length++
        }
      }

      this.$set(this.project, 'variables', {
        folders: folders,
        variables: this.globalVariables.variables
      })
    },
    async importGlobalVariable (hash) {
      VEvent.fire('loader', true)
      await axios.post(`/api/projects/${this.project.id}/import-variables`, {
        hash: hash.split(',')
      })
        .then(async () => {
          await this.$store.dispatch('projects/load')
          this.$swal({
            icon: 'success',
            title: 'Done!',
            text: 'The global variables have been imported.',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch((err) => {
          console.error(err)
          this.$swal({
            icon: 'error',
            title: 'Error!',
            text: 'There was an error while processing this transaction. Please try again',
            showConfirmButton: false,
            timer: 3500
          })
        })
        .finally(() => {
          VEvent.fire('loader', false)
        })
      this.importGlobalVariableModal = false
    },
    async save () {
      this.loading = true
      this.checkFolders()
      this.variableManage = null
      this.folderManage = null
      this.confirmSaveDialog = false
      VEvent.fire('loader', true)

      try {
        await this.$store.dispatch('projects/save', true)
        this.initVariables()
        this.$swal({
          icon: 'success',
          title: 'Saved!',
          showConfirmButton: false,
          timer: 1500
        })
      } finally {
        VEvent.fire('loader', false)
        this.loading = false
      }
    },
    removeOption (index) {
      this.project.variables.splice(index, 1)
      this.save()
    },
    addOption () {
      this.project.variables.push({
        name: '',
        key: '',
        value: ''
      })
    },
    initVariables () {
      this.initVariablesKeys = this.variablesKeys
    }
  },
  async mounted () {
    await this.$store.dispatch('projects/hasAccessToPage', 'project_settings.injection')
    await this.$store.dispatch('modal/fetch')
    await this.checkVariablesStructure()
    this.initVariables()
  }
}
</script>

<style>
.dropdown.show .btn:not(.no-focus) {
  border-color: transparent !important;
}

.global-variables-page .custom-checkbox .custom-control-label::after {
  border-color: #a1a1a1 !important;
}
</style>